import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "exclamation",
  "use": "exclamation-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 100 100\" id=\"exclamation\">\n  <path d=\"M50,5C25.147,5,5,25.147,5,50c0,24.853,20.147,45,45,45s45-20.147,45-45C95,25.147,74.853,5,50,5z M55,75H45V65h10V75z   M55,60H45V25h10V60z\">\n  </path>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol